import * as React from 'react';
import cn from 'classnames';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import Input from '../../Input';
import { emailRegex, useIsMobile } from '../../utils';
const ResendTicketsForm = ({ className, defaultEmail, onSubmit, submitRef }) => {
    const { ResendTicketsForm: css } = useTheme('ResendTicketsForm');
    const { t } = useTranslation('RegisteredPassenger');
    const isMobile = useIsMobile();
    return (React.createElement("div", { className: cn(className, css.wrapper) },
        React.createElement(Form, { onSubmit: onSubmit, initialValues: { email: defaultEmail }, render: ({ handleSubmit, form }) => {
                if (submitRef) {
                    submitRef.current = () => {
                        form.submit();
                    };
                }
                return (React.createElement("form", { onSubmit: handleSubmit },
                    React.createElement(Field, { name: 'email', validate: (value) => {
                            if (!value) {
                                return t('Required field');
                            }
                            if (!emailRegex.test(value)) {
                                return t('Please enter a valid email');
                            }
                        }, render: ({ input, meta }) => {
                            const validationError = meta.touched && meta.error ? meta.error : undefined;
                            const submitError = meta.submitError && !meta.dirtySinceLastSubmit ? meta.submitError : undefined;
                            const fieldError = validationError || submitError;
                            const helperText = fieldError || '';
                            return (React.createElement(Input, Object.assign({}, input, { inputClassName: cn(css.input, css.input_underline), inputFocusedClassName: css.input_focused, variant: isMobile ? 'standard' : 'filled', label: t('Email'), TextFieldProps: {
                                    error: Boolean(fieldError),
                                    helperText: React.createElement("span", { className: css.error }, helperText),
                                    onChange: (event) => {
                                        input.onChange(event);
                                    }
                                } })));
                        } })));
            } })));
};
export default ResendTicketsForm;
